import React from "react";
import Table from "react-bootstrap/Table";
import { useEffect } from "react";
import axios from ".././axios-interceptor";
import { useState } from "react";
import InvestorSideNavBar from "./SideNavBarInvestor";
import InvestorNavBarMain from "./InvestorNavBar";
import TableData from "../AdminFlow/TableData";
import moment from "moment/moment";

import { base_url, LOAN_CURRENCY_TYPE_BHD } from "./../utilities";
import Skeleton from "react-loading-skeleton";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Cookies from 'js-cookie';
import FundNowInvestments from "./FundNowInvestments";

const MyInvestments = (props) => {
  const navigate = useNavigate();
  useEffect(()=>{
    if (Cookies.get("User_Accesstoken_Investor") == null) {
      navigate('/');
    }
  },[])
  let ltwo = props.loading;
  const [servicedatafilter, setServiceDataFilter] = useState([]);
  const [loading, setLoading] = useState(true);
  const [investordataUser, setInvestordataUser] = useState([]);
  // loan_ids shown as Fund Now rows, so the legacy rows don't list them twice.
  const [fundNowLoanIds, setFundNowLoanIds] = useState([]);
  useEffect(() => {
    axios
      .post(base_url + "investor-master/get_investor_master_user", {
        user_id: Cookies.get("investor_user_id"),
      })
      .then((res) => {
        setInvestordataUser(res?.data?.data);
        axios
          .post(base_url + "investor-master/get_my_investments", {
            investor_id: res.data?.data?.investor_id,
          })
          .then((res) => {

            setServiceDataFilter(Array.isArray(res?.data?.data) ? res.data.data : []);
            setLoading(false);
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        if (err.response.statusText == "Unauthorized") {
          toast.error("Your session has expired. Please login again", {
            toastId: 7,
          });
          Cookies.remove("User_Accesstoken_Investor");
          Cookies.remove("User_Refreshtoken_Investor");
          navigate("/");
        }
      });
  }, []);
  const [hidecontent, setHideContent] = useState("d-block");
  const [shownextcontent, setShowNextContent] = useState("d-none");
  const [loanrefno, setLoanRefNo] = useState("");
  const [adminCurrency, setAdminCurrency] = useState("");
  const [loandatafilter, setLoandataFilter] = useState([]);
  const [paymentdataFilter, setPaymentdataFilter] = useState([]);
  const [chargesLoanId, setChargesLoanId] = useState("");
  const [charges, setCharges] = useState([]);
  const [chargesLoading, setChargesLoading] = useState(false);
  const [exchangeRate, setExchangeRate] = useState(1);

  const handleHideContent = (props) => {
    setHideContent("d-none");
    setShowNextContent("d-block");
    setLoanRefNo(props.loan_reference_number);
    setAdminCurrency(props.investors_currency);
    let filteredLoandata = servicedatafilter.filter((item) => {
      if (item.loan_reference_number == props.loan_reference_number) {
        return item;
      }
    });
    let receipts = filteredLoandata[0].my_receipts.map((item) => {
      return item;
    });
    let payments = filteredLoandata[0].my_payments.map((item) => {
      return item;
    });
    setLoandataFilter(receipts);
    setPaymentdataFilter(payments);

    const loan_id = filteredLoandata[0]?.loan_id;
    setChargesLoanId(loan_id);
    setExchangeRate(filteredLoandata[0]?.exchange_rate || 1);
    if (loan_id) {
      setChargesLoading(true);
      axios
        .post(base_url + 'loan-charges/get_charges_by_loan', { loan_id })
        .then((res) => {
          if (res.data.status === 200) setCharges(res.data.data);
        })
        .catch((err) => console.log(err))
        .finally(() => setChargesLoading(false));
    }
  };

  const [count, setCount] = useState();
  const [sortOrder, setSortOrder] = useState({ column: null, direction: null });
  const columns = [
    { title: "Invest Ref No.", field: "loan_reference_number" },
    {
      title: "Amount Invested",
      field: "final_loan_amount",
      currency: "investors_currency",
    },
    { title: "Principal Repaid (%)", field: "principal_repaid_percentage" },
    { title: "Monthly Profit", field: "investor_roi" },
    {
      title: "Net Returns",
      field: "net_returns",
      currency: "investors_currency",
    },
    {
      title: "Created Date",
      field: "created_date_time",
      currency: "investors_currency",
    },
    {
      title: "Actions",
      field: "image",
      image: "./images/icons/double_arrow.svg",
      datatopass: "loan_reference_number",
    },
  ];
  const handleSort = (column) => {
    let direction = "asc";
    if (sortOrder.column === column && sortOrder.direction === "asc") {
      direction = "desc";
    }
    setSortOrder({ column, direction });
    const sortedData = [...servicedatafilter].sort((a, b) => {
      const columnA =
        column == "loan_amount"
          ? parseInt(a[column])
          : column == "net_returns"
          ? parseInt(a[column])
          : a[column];
      const columnB =
        column == "loan_amount"
          ? parseInt(b[column])
          : column == "net_returns"
          ? parseInt(b[column])
          : b[column];
      if (typeof columnA === "string" && typeof columnB === "string") {
        return direction === "asc"
          ? columnA.localeCompare(columnB)
          : columnB.localeCompare(columnA);
      } else if (typeof columnA === "number" && typeof columnB === "number") {
        return direction === "asc" ? columnA - columnB : columnB - columnA;
      } else {
        return 0;
      }
    });
    setServiceDataFilter(sortedData);
  };

  const legacyRows = (servicedatafilter || []).filter(
    (row) => !fundNowLoanIds.includes(String(row.loan_id))
  );

  const renderTable = (extraItems) => (
    <Table striped className="my_loan_table">
      <TableData
        loanrefno={loanrefno}
        handleSort={handleSort}
        ltwo={ltwo}
        loading={loading}
        data={legacyRows}
        columns={columns}
        onImageClick={handleHideContent}
        extraItems={extraItems}
        sortState={sortOrder}
      />
    </Table>
  );

  const gobackToMyInvestments = () => {
    setShowNextContent("d-none");
    setHideContent("d-block");
  };
  return (
    <div style={{ display: "flex", height: "100vh" }}>
      <InvestorSideNavBar />
      <main style={{ width: "100%" }}>
        <InvestorNavBarMain businessname={investordataUser?.investor_name} />
        <div className={`content_main_body db_body ${hidecontent}`}>
          <div className="row d-flex flex-column ">
            <div className="col d-flex justify-content-between mt-1">
              <div className="investor_new_first_tab">My Investments</div>
            </div>
          </div>
          <div className={`row mt-3 `}>
            <div className="col mt-3 myinvestmts_table_div">
              {investordataUser?.investor_id ? (
                // Fund Now investments are merged into the same rows, sorted together (newest first).
                <FundNowInvestments
                  variant="items"
                  investorId={investordataUser.investor_id}
                  onLoaded={(rows) => setFundNowLoanIds(rows.map((r) => String(r.loan_id)))}
                >
                  {(items, withdrawalModal) => (
                    <>
                      {renderTable(items)}
                      {withdrawalModal}
                    </>
                  )}
                </FundNowInvestments>
              ) : (
                renderTable([])
              )}
            </div>
          </div>
        </div>
        <div>
          <div className={`${shownextcontent} `}>
            <div className="investor_new" onClick={gobackToMyInvestments}>
              <img src="./images/left_arrow.svg" alt="" />
              My Transactions
            </div>
            <div className="">
              <div className=" pe-5 ps-5">
                <ul className="nav nav-tabs d-flex" id="myTab" role="tablist">
                  <li className="nav-item-inv" role="presentation">
                    <button
                      className="nav-link-inv active p-1"
                      id="investors-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#myreceipts-tab-pane"
                      type="button"
                      role="tab"
                      aria-controls="myreceipts-tab-pane"
                      aria-selected="true"
                    >
                      <h3>My Receipts</h3>
                    </button>
                  </li>
                  <li className="nav-item-inv" role="presentation">
                    <button
                      // onClick={newInvestorIntrestsClick}
                      className="nav-link-inv p-1 x"
                      id="newinvestment-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#mypayments-tab-pane"
                      type="button"
                      role="tab"
                      aria-controls="mypayments-tab-pane"
                      aria-selected="false"
                    >
                      <h3>My Payments</h3>
                    </button>
                  </li>
                  <li className="nav-item-inv" role="presentation">
                    <button
                      className="nav-link-inv p-1"
                      id="invcharges-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#invcharges-tab-pane"
                      type="button"
                      role="tab"
                      aria-controls="invcharges-tab-pane"
                      aria-selected="false"
                    >
                      <h3>Additional Charges</h3>
                    </button>
                  </li>
                </ul>
              </div>
              <div
                className="tab-content idiv_inv_left_card_text pe-5 ps-5"
                id="myTabContent"
              >
                <div
                  className="tab-pane fade active show my_receipts_table"
                  id="myreceipts-tab-pane"
                  role="tabpanel"
                  aria-labelledby="investors-tab"
                  tabIndex="0"
                >
                  <MyTransactions
                    // handleSort={handleSort}
                    adminCurrency={adminCurrency}
                    ltwo={ltwo}
                    loading={loading}
                    loandata={loandatafilter}
                    loanrefno={loanrefno}
                  />
                </div>
                <div
                  className="tab-pane fade show"
                  id="mypayments-tab-pane"
                  role="tabpanel"
                  aria-labelledby="newinvestment-tab"
                  tabIndex="0"
                >
                  <MyPayments
                    adminCurrency={adminCurrency}
                    hide={() => setHideContent("d-block")}
                    showcontent={() => setShowNextContent("d-none")}
                    handleSort={handleSort}
                    ltwo={ltwo}
                    loading={loading}
                    loandata={paymentdataFilter}
                    loanrefno={loanrefno}
                  />
                </div>
                <div
                  className="tab-pane fade"
                  id="invcharges-tab-pane"
                  role="tabpanel"
                  aria-labelledby="invcharges-tab"
                  tabIndex="0"
                >
                  <div className="p-3">
                    <h6 className="mb-3">Additional Charges</h6>
                    {chargesLoading ? (
                      <div className="text-center mt-3" style={{ fontSize: 13, color: '#888' }}>
                        Loading...
                      </div>
                    ) : charges.length === 0 ? (
                      <div className="text-center mt-4" style={{ fontSize: 13, color: '#888' }}>
                        No additional charges for this loan.
                      </div>
                    ) : (
                      <table className="table table-striped" style={{ fontSize: 13 }}>
                        <thead>
                          <tr>
                            <th>Type of Charge</th>
                            <th>Description</th>
                            <th>Amount</th>
                            <th>Charge Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {charges.map((charge, index) => (
                            <tr key={index}>
                              <td>{charge.charge_type}</td>
                              <td>{charge.description || '—'}</td>
                              <td>
                                {adminCurrency === LOAN_CURRENCY_TYPE_BHD ? (
                                  <div style={{ fontWeight: 500 }}>
                                    BHD {Number(charge.investor_allocation).toFixed(2)}
                                  </div>
                                ) : (
                                  <div>
                                    <div style={{ fontWeight: 500 }}>
                                      BHD {Number(charge.investor_allocation).toFixed(2)}
                                    </div>
                                    <div style={{ fontSize: 12, color: '#555', marginTop: 2 }}>
                                      $&nbsp;{Math.round(Number(charge.investor_allocation) * exchangeRate * 100) / 100}
                                    </div>
                                  </div>
                                )}
                              </td>
                              <td>{moment(charge.charge_date).format('DD MMM YYYY')}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default MyInvestments;

export const MyTransactions = (props) => {
  let admin_request_loan_currency = props.adminCurrency;
  let loandatafilter = props.loandata;

  let loanrefno = props.loanrefno;
  let ltwo = props.ltwo;
  let loading = props.loading;

  const [sortOrder, setSortOrder] = useState({ column: null, direction: null });
  const [sortedLoandata, setSortedLoandata] = useState([]);
  const columns = [
    { title: "Transaction ID", field: "transaction_reference_no" },
    { title: "Loan ID", field: "loanrefno" },
    { title: "Amount", field: "paid_amount" },
    { title: "Particular", field: "paid_principal" },
    { title: "Date Received", field: "paid_date" },
  ];
  const handleSort = (column) => {
    let direction = "asc";
    if (sortOrder.column === column && sortOrder.direction === "asc") {
      direction = "desc";
    }
    setSortOrder({ column, direction });
  };

  useEffect(() => {
    const sortedData = [...loandatafilter].sort((a, b) => {
      const columnA =
        sortOrder.column === "loan_amount"
          ? parseInt(a["loan_amount"])
          : sortOrder.column === "net_returns"
          ? parseInt(a["net_returns"])
          : a[sortOrder.column];
      const columnB =
        sortOrder.column === "loan_amount"
          ? parseInt(b["loan_amount"])
          : sortOrder.column === "net_returns"
          ? parseInt(b["net_returns"])
          : b[sortOrder.column];
      if (typeof columnA === "string" && typeof columnB === "string") {
        return sortOrder.direction === "asc"
          ? columnA.localeCompare(columnB)
          : columnB.localeCompare(columnA);
      } else if (typeof columnA === "number" && typeof columnB === "number") {
        return sortOrder.direction === "asc"
          ? columnA - columnB
          : columnB - columnA;
      } else {
        return 0;
      }
    });
    setSortedLoandata(sortedData);
  }, [loandatafilter, sortOrder]);
  return (
    <div className="mytrx_myrecpts">
      <Table responsive striped 
       className="">
        <thead className="">
          <tr>
            {columns.map((header, index) => (
              <th
                className={`Cpointer ${header.title ==='Transaction ID'?'text-center':''}`}
                key={header.field}
                onClick={() => handleSort(header.field)}
              >
                {ltwo || loading ? (
                  <Skeleton width={100} height={15} />
                ) : header.title !== "Actions" ? (
                  <>
                    {" "}
                    {header.title}
                    &#9662;
                  </>
                ) : (
                  header.title
                )}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {sortedLoandata.map((service, index) => {
            return (
              <tr key={index}>
                <td>
                  {ltwo || loading ? (
                    <Skeleton width={100} height={15} />
                  ) : (
                    <div className="text-center">{service.transaction_reference_no}</div>
                  )}
                </td>
                <td>
                  {ltwo || loading ? (
                    <Skeleton width={100} height={15} />
                  ) : (
                    loanrefno
                  )}
                </td>
                <td>
                  {ltwo || loading ? (
                    <Skeleton width={100} height={15} />
                  ) : admin_request_loan_currency === LOAN_CURRENCY_TYPE_BHD ? (
                    <div style={{ fontWeight: 500 }}>
                      BHD {Number(service.paid_amount).toLocaleString()}
                    </div>
                  ) : (
                    <div>
                      <div style={{ fontWeight: 500 }}>
                        BHD {Number(service.paid_amount_bhd).toLocaleString()}
                      </div>
                      <div style={{ fontSize: 12, color: '#555', marginTop: 2 }}>
                        $&nbsp;{Number(service.paid_amount).toLocaleString()}
                      </div>
                    </div>
                  )}
                </td>
                <td>
                  {ltwo || loading ? (
                    <Skeleton width={100} height={15} />
                  ) : service.paid_principal === undefined ? (
                    "-"
                  ) : service.paid_principal === 0 ? (
                    "Interest"
                  ) : service.paid_amount - service.paid_principal === 0 &&
                    service.is_tenure_both_principal_interest === 0 ? (
                    "Principal"
                  ) : (
                    "Principal & Interest"
                  )}
                </td>
                <td>
                  {ltwo || loading ? (
                    <Skeleton width={100} height={15} />
                  ) : (
                    moment(service.paid_date).format("DD MMM YYYY")
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

export const MyPayments = (props) => {
  let admin_request_loan_currency = props.adminCurrency;
  let loandatafilter = props.loandata;
  // let loandata = props.loandata;
  let loanrefno = props.loanrefno;
  let handleSort = props.handleSort;
  let ltwo = props.ltwo;
  let loading = props.loading;
  const columns = [
    { title: "Transaction ID" },
    { title: "Loan ID" },
    { title: "Amount" },
    { title: "Paid Via" },
    { title: "Date Paid" },
  ];

  return (
    <div className="mytrx_mypaymnts">
      <Table responsive striped  >
        <thead className="">
          <tr>
            {columns.map((header, index) => (
              <th
                className={`Cpointer ${header.title ==='Transaction ID'?'text-center':''}`}
                key={header.title}
                onClick={() => handleSort(header.title)}
              >
                {ltwo || loading ? (
                  <Skeleton width={100} height={15} />
                ) : header.title !== "Actions" ? (
                  <>
                    {" "}
                    {header.title}
                    &#9662;
                  </>
                ) : (
                  header.title
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {loandatafilter.map((service, index) => {
            return (
              <tr key={index}>
                <td>
                  {ltwo || loading ? (
                    <Skeleton width={100} height={15} />
                  ) : (
                    <div className="text-center">{service.payment_to_business_reference_no}</div>
                  )}
                </td>
                <td>
                  {ltwo || loading ? (
                    <Skeleton width={100} height={15} />
                  ) : (
                    loanrefno
                  )}
                </td>
                <td>
                  {ltwo || loading ? (
                    <Skeleton width={100} height={15} />
                  ) : admin_request_loan_currency === LOAN_CURRENCY_TYPE_BHD ? (
                    <div style={{ fontWeight: 500 }}>
                      BHD {Number(service.paid_amount).toLocaleString()}
                    </div>
                  ) : (
                    <div>
                      <div style={{ fontWeight: 500 }}>
                        BHD {Number(service.paid_amount_bhd).toLocaleString()}
                      </div>
                      <div style={{ fontSize: 15, color: '#555', marginTop: 2 }}>
                        $&nbsp;{Number(service.paid_amount).toLocaleString()}
                      </div>
                    </div>
                  )}
                </td>
                <td>
                  {ltwo || loading ? (
                    <Skeleton width={100} height={15} />
                  ) : service.paid_via === undefined ? (
                    "-"
                  ) : (
                    service.paid_via
                  )}
                </td>
                <td>
                  {ltwo || loading ? (
                    <Skeleton width={100} height={15} />
                  ) : (
                    moment(service.paid_date).format("DD MMM YYYY")
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};
